import type { MeetingTelemetryLevel, MeetingTelemetryPlatform, MeetingTelemetryTypesDto } from '@saas/api-client';

export type TelemetryFlag = MeetingTelemetryTypesDto['flag'];

export type FlagBadgeVariant = 'destructive' | 'warning';

export const TELEMETRY_FLAGS = [
	'PERMISSION_DENIED_SITE',
	'PERMISSION_DENIED_OS',
	'DEVICE_IN_USE',
	'NO_DEVICE',
	'OVERCONSTRAINED',
	'INSECURE_CONTEXT',
	'UNSUPPORTED_BROWSER',
	'SILENT_MIC',
	'MIC_NO_BYTES',
	'PLAYBACK_BLOCKED',
	'SPEAKER_SELECTION_UNSUPPORTED',
	'JOIN_FAILED_TOKEN',
	'JOIN_FAILED_SIGNAL',
	'JOIN_FAILED_ICE',
	'RELAY_ONLY',
	'UDP_BLOCKED',
	'RECONNECT_LOOP',
	'DROPPED',
	'DUPLICATE_IDENTITY',
	'STATE_MISMATCH',
	'CPU_LIMITED',
	'BANDWIDTH_LIMITED',
	'HIGH_LOSS',
	'HIGH_RTT',
	'HIGH_JITTER',
	'VIDEO_FREEZES',
	'AUDIO_CONCEALMENT',
	'BACKGROUND_CAPTURE_LOST',
	'CLOCK_SKEW',
	'CLIENT_TELEMETRY_MISSING',
	'SERVER_EVENTS_MISSING',
	'RECORDING_FAILED',
	'AGENT_NO_AUDIO',
	'ONE_WAY_MEDIA',
] as const satisfies readonly TelemetryFlag[];

export const isTelemetryFlag = (value: string): value is TelemetryFlag =>
	TELEMETRY_FLAGS.some((flag) => flag === value);

const ERROR_FLAGS: ReadonlySet<string> = new Set<TelemetryFlag>([
	'PERMISSION_DENIED_SITE',
	'PERMISSION_DENIED_OS',
	'DEVICE_IN_USE',
	'NO_DEVICE',
	'OVERCONSTRAINED',
	'INSECURE_CONTEXT',
	'UNSUPPORTED_BROWSER',
	'MIC_NO_BYTES',
	'PLAYBACK_BLOCKED',
	'JOIN_FAILED_TOKEN',
	'JOIN_FAILED_SIGNAL',
	'JOIN_FAILED_ICE',
	'RECONNECT_LOOP',
	'DROPPED',
	'RECORDING_FAILED',
	'AGENT_NO_AUDIO',
	'ONE_WAY_MEDIA',
]);

export const flagBadgeVariant = (flag: string): FlagBadgeVariant => (ERROR_FLAGS.has(flag) ? 'destructive' : 'warning');

export type QualityBadgeVariant = 'success' | 'warning' | 'destructive';

export const qualityBadgeVariant = (quality: string): QualityBadgeVariant => {
	if (quality === 'good') return 'success';
	if (quality === 'fair') return 'warning';
	return 'destructive';
};

export const TELEMETRY_PLATFORMS = ['web', 'ios', 'android'] as const satisfies readonly MeetingTelemetryPlatform[];

export const TIMELINE_LEVELS = ['info', 'warn', 'error'] as const satisfies readonly MeetingTelemetryLevel[];

export type TimelineLevel = (typeof TIMELINE_LEVELS)[number];

export const TELEMETRY_PAGE_SIZE = 20;

export const TELEMETRY_MAX_PAGE_SIZE = 50;

export const TIMELINE_PAGE_SIZE = 100;

export const SAMPLE_POINTS = 60;

export const LIVE_REFETCH_MS = 30_000;
